
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { ComponentDocs, Preview } from "@lighting-beetle/lighter-styleguide";
import Image from "./index";

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1>{`Image`}</h1>
    <h2>{`Example`}</h2>
    <Image src="http://placehold.it/150x150" alt="Example" mdxType="Image" />}
    <h2>{`Variants`}</h2>
    <h3>{`Basic`}</h3>
    <Preview mdxType="Preview">
  <Image src="http://placehold.it/150x150" alt="Example" mdxType="Image" />
    </Preview>
    <h3>{`Fluid`}</h3>
    <Preview mdxType="Preview">
  <Image fluid src="http://placehold.it/300x300" alt="Fluid" mdxType="Image" />
    </Preview>
    <h3>{`Rounded`}</h3>
    <Preview mdxType="Preview">
  <Image rounded src="http://placehold.it/150x150" alt="Rounded" mdxType="Image" />
    </Preview>
    <h3>{`Circle`}</h3>
    <Preview mdxType="Preview">
  <Image circle src="http://placehold.it/150x150" alt="Circle" mdxType="Image" />
    </Preview>
    <h2>{`Props`}</h2>
    <ComponentDocs title="<Image />" component={Image} mdxType="ComponentDocs" />
    <h2>{`Accessibility`}</h2>
    <p>{`The `}<inlineCode parentName="p">{`alt`}</inlineCode>{` attribute should be used to provide a meaningful textual alternative unless the image is puerly presentational and would not double a textual description. Check `}<a parentName="p" {...{
        "href": "https://webaim.org/techniques/alttext/"
      }}>{`How to write alternative texts`}</a>{` to learn more.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;